import wixLocation from 'wix-location';

$w.onReady(function () {
	// let par = url.slice(baseUrl.length, url.length);
	// let url = wixLocation.url;
	// let baseUrl = wixLocation.baseUrl;
	// console.log(url)

	// console.log(par)

	// if (par === "?course2") {
	// 	$w("#anchor3").scrollTo();

	// }

	// if (par === "?scroll_test") {
	// 	$w("#footer1").scrollTo();

	// }




	let queryParams = wixLocation.query;
	if(queryParams.hasOwnProperty('course')) {
		if(queryParams.course == '1'){
				$w("#anchor2").scrollTo();
		} else { 
				$w("#anchor3").scrollTo();
		}
	}

	

	console.log(queryParams);
});